import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { customerOperations } from '../stores/customer-store'
import { PlansService } from '../services/plans-service'
import { errorToast } from '../toaster'
import { donePromise } from '../utils'

@Injectable({providedIn: 'root'})
export class PlanActions {
  plansService = new PlansService();

  loadPlans() {
    const p = this.plansService.getPlans().then(plans => {
      reactor.dispatch(customerOperations.setPlans, plans)
    })
    .catch(() => {
      errorToast('Plan info failed to load, please reload the page')
    })
    return donePromise(p)
  }
}
